import { useLocation } from "react-router-dom";
// import OperationGuide from '../pages/operationGuide/operationGuide';

const menuRouterMapper = {
  F00001: "/management/operationGuide",
  F10101: "/management/dashboard",
  F10103: "/management/carbonFootprint",
  F10201: "/management/personalProfile",
  F10202: "/management/changePcode",
  F20101: "/management/companyDataRegistration",
  F20102: "/management/subAccountSetting",
  F202: "/management/rolePermission",
  F20201: "/management/rolePermission",
  F20301: "/management/accountActivity",
  B20101: "/management/funcList",
  B20201: "/management/noticeRecord",
  B10201: "/management/companyList",
  B20102: "/management/companyBinding",
  B10102: "/management/inviteRecord",
  B10101: "/management/accountList",
  F10401: "/management/companyFile",
  F10402: "/management/placeMaintain",
  F10403: "/management/companyDataSetting",
  F10404: "/management/companyOffering",
  F10405: "/management/boundaryDevice",
  F105: "/management/productCarbonFootprint",
  F10501: "/management/productCarbonFootprint",
  F10502: "/management/serviceCarbonFootprint",
  F10503: "/management/inventoryCarbonFootprint",
  B20103: "/management/setting",
  B20104: "/management/memberPermissionSetting",
  B20105: "/management/cache",
  B20301: "/management/analyze",
  F106: "/management/equipmentProcessSettings",
  F10601: "/management/equipmentProcessSettings",
  F10602: "/management/productProcessSettings",
  F10603: "/management/cbam",
  B20302: "/management/companyStatsList",
  B20401: "/management/userDashboard",
  B20501: "/management/emissionSourceFactor",
};

export const getMenuRouter = (functionId) => {
  return menuRouterMapper[functionId] || "/management/*";
};

export const getRouterFunctionId = (pathname) => {
  return Object.keys(menuRouterMapper).find((key) => menuRouterMapper[key] === pathname) || "";
};

export const useFuncId = () => {
  const location = useLocation();
  const pathname = location.pathname;

  let matchedKey = null;
  let longestMatchLength = 0;

  for (const [key, path] of Object.entries(menuRouterMapper)) {
    if (pathname.indexOf(path) !== -1 && path.length > longestMatchLength) {
      matchedKey = key;
      longestMatchLength = path.length;
    }
  }

  return matchedKey;
};
